export * from './quillEditor.module';



// WEBPACK FOOTER //
// ./~/ng2-quill-editor/index.ts